/* Chocolate Counter - Build Your Own Box cart grouping. V_1_0 (Oct 29, 2026).
   Loaded globally from layout/theme.liquid so "Remove box" works inside the ajax cart drawer
   (markup injected with innerHTML never runs inline scripts) as well as on the /cart page.
   Pairs with snippets/cart.byob-box.liquid. */
(function () {
  if (window.__byobCartBound) return;
  window.__byobCartBound = true;
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-byob-remove]'); if (!btn) return;
    const box = btn.closest('[data-byob-box]'); if (!box) return;
    const keys = (box.dataset.byobKeys || '').split(',').filter(Boolean);
    if (!keys.length) return;
    btn.disabled = true; btn.textContent = 'Removing…';
    const updates = {}; keys.forEach(k => { updates[k] = 0; });
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    try {
      const res = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates, sections: 'cart-ajax' }) });
      if (!res.ok) throw new Error('update failed');
      const state = await res.json();
      document.dispatchEvent(new CustomEvent('byob:removed', { detail: { boxId: box.dataset.byobBox } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
      const onCartPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname);
      if (onCartPage || (!document.querySelector('header-cart-drawer') && !document.getElementById('CartPageForm'))) window.location.reload();
    } catch (err) {
      btn.disabled = false; btn.textContent = 'Remove box';
    }
  });
})();
